import storageService from "@/services/middleware/storageService";
import type { MetricColumn } from "@/types/model/Analytics";

export const hiddenReportFields = [
  { name: "Labels", key: "labels" },
  { name: "Status", key: "status" },
  { name: "Fraud severity", key: "fraudHitsSeverity" },
  { name: "Fraud severity", key: "fraudConversionsSeverity" },
  { name: "Traffic Veracity", key: "trafficVeracityHits" },
  { name: "Traffic Veracity", key: "trafficVeracityConversions" },
];

export const percTotalsList = [
  { name: "Invalid traffic", key: "highRiskHitsPerc" },
  { name: "Suspicious traffic", key: "mediumRiskHitsPerc" },
  { name: "Legitimate Traffic", key: "lowRiskHitsPerc" },
  { name: "Invalid traffic", key: "highRiskConversionsPerc" },
  { name: "Suspicious traffic", key: "mediumRiskConversionsPerc" },
  { name: "Legitimate traffic", key: "lowRiskConversionsPerc" },
];

export const metricsList: Array<MetricColumn> = [
  { name: "Status", key: "status", group: "general" },
  { name: "Labels", key: "labels", group: "general" },
  { name: "Sessions", key: "title", group: "sessions" },
  { name: "Total Sessions", key: "sessions", group: "sessions" },
  {
    name: "Traffic Veracity",
    key: "trafficVeracitySessions",
    group: "sessions",
  },
  { name: "Invalid traffic", key: "highRiskSessions", group: "sessions" },
  { name: "Suspicious traffic", key: "mediumRiskSessions", group: "sessions" },
  { name: "Legitimate Traffic", key: "lowRiskSessions", group: "sessions" },
  { name: "Page views", key: "title", group: "hits" },
  { name: "Total Page Views", key: "hits", group: "hits" },
  { name: "Traffic Veracity", key: "trafficVeracityHits", group: "hits" },
  { name: "Invalid traffic", key: "highRiskHits", group: "hits" },
  { name: "Suspicious traffic", key: "mediumRiskHits", group: "hits" },
  { name: "Legitimate Traffic", key: "lowRiskHits", group: "hits" },
  { name: "Delivered", key: "allowedHits", group: "hits" },
  { name: "Paused", key: "pausedHits", group: "hits" },
  { name: "Blocked", key: "blockedHits", group: "hits" },
  { name: "Conversions", key: "title", group: "conversion" },
  { name: "Total conversions", key: "conversions", group: "conversion" },
  {
    name: "Traffic Veracity",
    key: "trafficVeracityConversions",
    group: "conversion",
  },
  { name: "Invalid traffic", key: "highRiskConversions", group: "conversion" },
  {
    name: "Suspicious traffic",
    key: "mediumRiskConversions",
    group: "conversion",
  },
  {
    name: "Legitimate traffic",
    key: "lowRiskConversions",
    group: "conversion",
  },
  {
    name: "Reported conversions",
    key: "conversionsReported",
    group: "conversion",
  },
  { name: "Paused conversions", key: "pausedConversions", group: "conversion" },
  { name: "Non reported", key: "conversionsNotReported", group: "conversion" },
  { name: "Publisher CR", key: "allowedConversionRate", group: "general" },
  { name: "Advertiser CR", key: "advertiserConversionRate", group: "general" },
  { name: "Global CR", key: "conversionRate", group: "general" },
  { name: "Revenue", key: "revenue", group: "general" },
  { name: "Cost", key: "cost", group: "general" },
  { name: "Profit", key: "profit", group: "general" },
  { name: "ROI", key: "roi", group: "general" },
];

export const defaultMetrics: Array<string> = [
  "sessions",
  "hits",
  "trafficVeracityHits",
  "highRiskHits",
  "mediumRiskHits",
  "allowedHits",
  "conversions",
  "trafficVeracityConversions",
  "highRiskConversions",
  "mediumRiskConversions",
  "lowRiskConversions",
  "conversionsReported",
  "allowedConversionRate",
  "cost",
];

export const metricsKeyObject = (() => {
  const obj: {
    [k: string]: string;
  } = {};

  const metrics = metricsList.concat(percTotalsList);
  metrics.forEach((metric) => {
    if (metric.key.includes("RiskConversions")) {
      obj[metric.key] = "Conversions ".concat(metric.name);
    } else if (metric.key.includes("RiskHits")) {
      obj[metric.key] = "Page Views ".concat(metric.name);
    } else {
      obj[metric.key] = metric.name;
    }
  });

  return obj;
})();

export const calculateDefaultMetrics = () => {
  const metrics = storageService.getItem("metrics");
  if (metrics) {
    return {
      keys: metrics,
      list: metricsList.filter((e) => metrics.indexOf(e.key) > -1),
    };
  }
  return {
    keys: defaultMetrics,
    list: metricsList.filter((e) => defaultMetrics.indexOf(e.key) > -1),
  };
};

export const hiddenMetricsWithoutFirewall: Array<MetricColumn> = [
  { name: "Labels", key: "labels", group: "general" },
  { name: "Delivered", key: "allowedHits", group: "hits" },
  { name: "Paused", key: "pausedHits", group: "hits" },
  { name: "Blocked", key: "blockedHits", group: "hits" },
  {
    name: "Reported conversions",
    key: "conversionsReported",
    group: "conversion",
  },
  { name: "Paused conversions", key: "pausedConversions", group: "conversion" },
  { name: "Non reported", key: "conversionsNotReported", group: "conversion" },
  { name: "Publisher CR", key: "allowedConversionRate", group: "general" },
  { name: "Advertiser CR", key: "advertiserConversionRate", group: "general" },
  { name: "Revenue", key: "revenue", group: "general" },
  { name: "Cost", key: "cost", group: "general" },
  { name: "Profit", key: "profit", group: "general" },
  { name: "ROI", key: "roi", group: "general" },
];
